import {
  axiosDelete,
  axiosGet,
  axiosPatch,
  axiosPost,
  fetchImage,
} from '../axios/axios.config';

export const searchUsers = async (data) => {
  const response = await axiosGet('data/api/types/user', data);
  return response;
};

export const createUser = async (data) => {
  const response = await axiosPost('data/api/types/user', data);
  return response;
};

export const updateUser = async (userId, data) => {
  const response = await axiosPatch(`data/api/types/user/${userId}`, data);
  return response;
};

export const deleteUser = async (userId) => {
  const response = await axiosDelete(`data/api/types/user/${userId}`);
  return response;
};

export const getUserImage = async (userId) => {
  const response = await fetchImage(`data/api/types/user/${userId}/avatar`, {
    responseType: 'arraybuffer',
  });
  return response;
};

export const updateUserImage = async (userId, data) => {
  const response = await axiosPost(`data/api/types/user/${userId}`, data);
  return response;
};

export const updateUserPassword = async (token, data) => {
  // console.log(token, "tokenn111111111111");
  // console.log(data, "dataaaa111111111111111111");
  const response = await axiosPatch(
    `provider/api/types/user/?token=${token}`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      // headers: {
      //   'Content-Type': 'application/json',
      //   s_id: getSID()
    }
  );
  return response;
};

export const searchUserProfile = async (data) => {
  const response = await axiosGet(`data/api/types/userprofile`, data);
  return response;
};

export const userForgotPassword = async (emailId, data) => {
  const response = await axiosPost(`provider/password/reset/${emailId}`, data);
  return response;
};
